import React, { useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import io from "socket.io-client";

// Components
import Loader from "./components/Loader";
import ScrollManager from "./components/ScrollManager";

// ✅ Lazy load Screens (Route-level)
const Agrifresh = lazy(() => import("./screen/Agrifresh"));
const Home = lazy(() => import("./screen/Home"));
const Shop = lazy(() => import("./screen/AgriFreshShop"));
const Brand = lazy(() => import("./screen/Brand"));
const About = lazy(() => import("./screen/About"));
const Contact = lazy(() => import("./screen/Contact"));
const Infrastructure = lazy(() => import("./screen/Infrastructure"));
const InnerBrand = lazy(() => import("./screen/InnerBrand"));

//  SOCKET (AUTO FALLBACK: polling → websocket)
const socket = io("https://api.agrifresh.ae", {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  timeout: 20000,
});

function App() {
  const [loading, setLoading] = useState(true);

  //  SOCKET CONNECT ONCE
  useEffect(() => {
    socket.connect();

    socket.on("connect", () => {
      console.log("✅ Socket connected:", socket.id);
    });

    socket.on("connect_error", (err) => {
      console.error("❌ Socket error:", err.message);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  //  Loader
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
    <BrowserRouter>
      <ScrollManager />

      {/* ✅ Suspense for all routes */}
      <Suspense fallback={<div className="text-center py-5">Loading page...</div>}>
        <Routes>
          <Route path="/" element={<Agrifresh />}>
            <Route index element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/infrastructure" element={<Infrastructure />} />
            <Route path="/brands" element={<Brand />} />
            <Route path="/brand/:brand" element={<InnerBrand />} />
            <Route path="*" element={<h1>404 Error</h1>} />
          </Route>

          <Route path="404" element={<h1>404 Error</h1>} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;